import DraggableScrollArea from "@/components/DraggableScrollArea";
import { StarIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import Image from "next/image";
import { useMediaQuery } from "@react-hook/media-query";

const colourways = ["rust", "violet", "teal", "red"];

const TestimonialsSection = ({ testimonials }) => {
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div className={clsx("space-y-4 text-white lg:space-y-6 2xl:space-y-8")}>
      <DraggableScrollArea>
        <div className={clsx("flex space-x-6")}>
          {testimonials.map(
            ({ key, textContent, authorName, reviewRating, image }, index) => {
              return (
                <div
                  className={`flex w-[320px] flex-col gap-6 rounded-lg lg:h-[494px] lg:w-[774px] lg:flex-row bg-${
                    colourways[index % colourways.length]
                  } p-6`}
                >
                  {image?.[0] && (
                    <div className="h-[280px] w-[280px] rounded-lg lg:min-h-[440px] lg:min-w-[343px]">
                      <Image
                        src={image[0].url}
                        alt={image[0].title}
                        style={{
                          objectFit: "cover",
                        }}
                        width="343"
                        height="440"
                        className="h-[280px] w-[280px] rounded-lg lg:h-[440px] lg:w-[343px]"
                      />
                    </div>
                  )}
                  <div
                    key={key}
                    className={clsx(
                      "flex select-none snap-center snap-always flex-col justify-between space-y-4 lg:w-[400px] lg:w-[500px] lg:snap-none"
                    )}
                  >
                    <_StarRating rating={reviewRating ?? "5"} />
                    <div
                      className={clsx(
                        "font-spatial text-[22px] font-extralight lg:text-[32px]"
                      )}
                      dangerouslySetInnerHTML={{ __html: textContent }}
                    />
                    {authorName && (
                      <p className="font-body text-sm font-medium">
                        {authorName}
                      </p>
                    )}
                  </div>
                </div>
              );
            }
          )}
        </div>
      </DraggableScrollArea>
    </div>
  );
};

const _StarRating = ({ rating }) => {
  const ratingStr = rating.toString();
  const isHalfStar = rating.endsWith("5") && rating !== "5";
  const fullStars = rating
    ? parseInt(ratingStr[0], 10)
    : parseInt(ratingStr, 10);

  // Generate the star icons
  const stars = [];
  for (let i = 0; i < fullStars; i++) {
    stars.push(<StarIcon key={i} className={"h-6 w-6"} />);
  }

  if (isHalfStar) {
    stars.push(
      <StarIcon
        key={fullStars}
        className={"h-6 w-6"}
        style={{ clipPath: "polygon(0 0, 50% 0, 50% 100%, 0% 100%)" }}
      />
    );
  }

  return <div className="flex">{stars}</div>;
};

export default TestimonialsSection;
